import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { COLORS, FONTS, fadeUpVariant } from "./Hero.styles";

/**
 * HeroContent
 *
 * Left-column headline stack: eyebrow badge, H1, subtitle.
 * Single <h1> on the page lives here (component="h1" on the Typography below).
 */
export default function HeroContent() {
  return (
    <Box sx={{ textAlign: { xs: "center", lg: "left" } }}>
      {/* Eyebrow badge */}
      <motion.div {...fadeUpVariant(0)}>
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            px: "14px",
            py: "6px",
            mb: { xs: "20px", md: "24px" },
            borderRadius: "999px",
            background: "rgba(30,144,255,0.06)",
            border: `1px solid ${COLORS.borderHover}`,
            mx: { xs: "auto", lg: 0 },
            width: "fit-content",
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: COLORS.primary,
            }}
          />
          <Typography
            sx={{
              fontFamily: FONTS.body,
              fontSize: "0.78rem",
              color: "rgba(255,255,255,0.65)",
              fontWeight: 500,
              letterSpacing: "0.02em",
            }}
          >
            Enterprise AI Platform
          </Typography>
        </Box>
      </motion.div>

      {/* H1 — single heading on the page */}
      <motion.div {...fadeUpVariant(0.08, 18)}>
        <Typography
          component="h1"
          sx={{
            fontFamily: FONTS.display,
            fontWeight: 800,
            fontSize: "clamp(2.1rem, 4.6vw, 4.1rem)",
            letterSpacing: "clamp(-1.2px, -0.045em, -2.4px)",
            lineHeight: 1.08,
            color: COLORS.white,
            maxWidth: { xs: "100%", lg: "640px" },
            mx: { xs: "auto", lg: 0 },
          }}
        >
          Enterprise AI
          <br />
          Built for{" "}
          <Box component="span" sx={{ color: COLORS.primary }}>
            Mission-Critical
          </Box>{" "}
          Operations
        </Typography>
      </motion.div>

      {/* Subtitle */}
      <motion.div {...fadeUpVariant(0.16, 14)}>
        <Typography
          sx={{
            fontFamily: FONTS.body,
            fontWeight: 400,
            fontSize: "clamp(0.95rem, 1.2vw, 1.1rem)",
            lineHeight: 1.7,
            color: COLORS.textMuted,
            mt: { xs: "18px", md: "22px" },
            maxWidth: { xs: "100%", sm: "520px", lg: "560px" },
            mx: { xs: "auto", lg: 0 },
          }}
        >
          We design and deploy AI agents, voice AI, multilingual systems, and
          RAG-based LLM platforms for enterprise environments. Our infrastructure
          powers automation and decision-making at production scale.
        </Typography>
      </motion.div>
    </Box>
  );
}